/**
 * Manage the icon-based dropdown menu below the 'Our Dishes' menu item
 */

/* global jQuery */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process


function wireEvents() {

    let timer = null;
    
    // Wire the 'Our Dishes' nav icon
    $('.site-header__nav li:first-child a').mouseenter((event) => {
        clearTimeout(timer);
        openMenu();
    }).mouseleave((event) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            closeMenu();
        }, 500);
    });

    // Also wire the dish menu itself -- moving out of the menu area will close it
    $('.dish-filter-menu').mouseenter((event) => {
        clearTimeout(timer);
    }).mouseleave((event) => {
        timer = setTimeout(() => {
            closeMenu();
        }, 500);
    });
    

    function openMenu() {
        // Manage the opening of the dropdown icon menu
        $('.site-header__dish-filter-menu').slideDown(500, 'easeInOutQuart');
    }
    function closeMenu() {
        // Manage the closing of the dropdown icon menu
        $('.site-header__dish-filter-menu').slideUp(500, 'easeInOutQuart');
    }

}

exports.init = function () {
    wireEvents();
};